import { Editor } from 'tinymce';
import { isAtRangeStart } from 'controls/designer/features/widgets/textWidget/components/text-widget-editor/utils/isAtRangeEdge';

export function isAtContentStart(ed: Editor, selectionRng: Range): boolean {
	const contentContainer = ed.contentDocument.getElementById('tinymce');
	return isAtRangeStart(selectionRng, contentContainer);
}
